export const bookmarks = [
  {
    id: 1,
    postId: 1,
    userId: "01010000000",
  },
];
